import { render, staticRenderFns } from "./SiteLoader.vue?vue&type=template&id=4a7a4503&scoped=true&"
import script from "./SiteLoader.vue?vue&type=script&lang=js&"
export * from "./SiteLoader.vue?vue&type=script&lang=js&"
import style0 from "./SiteLoader.vue?vue&type=style&index=0&id=4a7a4503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a4503",
  null
  
)

export default component.exports